import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import { DocLinkIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { rootStyles } from './TeamChatFieldAnchor.styles';
import { scrollToAndHighlightAnchor } from './TeamChatFieldAnchor.utils';

const TeamChatFieldAnchor = memo(({ label, anchor }) => {
  const onClick = useCallback(() => {
    scrollToAndHighlightAnchor(anchor);
  }, [anchor]);

  return (
    <Box component="button" sx={rootStyles} type="button" onClick={onClick}>
      <DocLinkIcon size={IconSize[16]} />
      <Typography variant="medium12">{`re: ${label}`}</Typography>
    </Box>
  );
});
TeamChatFieldAnchor.propTypes = {
  anchor: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default TeamChatFieldAnchor;
